import { Component, ElementRef, ViewChild } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilService } from '../../services/util.service';
import { ConstantService } from '../../services/constant.service';
import { CommonService } from '../../services/common.service';
import { FinBoxStatusReq, GetVendorURLReq, VendorStatusReq } from '../../models/request.model';
import { IncomeProofBottomsheetComponent } from '../../components/income-proof-bottomsheet/income-proof-bottomsheet.component';
import { ConfirmationBottomsheetComponent } from '../../components/confirmation-bottomsheet/confirmation-bottomsheet.component';
import { clevertapPush, ModificationCommonService } from '../../services/modification-common.service';
import { UserSessionService } from '../../services/user-session.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackbarComponent } from '../../snackbar/snackbar.component';
import { UserSession } from '../../models/response.model';
import { LoaderbotomsheetComponent } from '../../components/loaderbotomsheet/loaderbotomsheet.component';
import { MatDialog } from '@angular/material/dialog';


@Component({
  selector: 'app-missing-details',
  imports: [CommonModule],
  templateUrl: './missing-details.component.html',
  styleUrl: './missing-details.component.less'
})
export class MissingDetailsComponent {
    @ViewChild('loaderBtn') loaderBtn!: ElementRef<HTMLButtonElement>;
  pushSegmentResponse: any;
    session_id!: string;
    respMsg!: string;
    respStatus!: number;
    btnTxt: string = 'YES';
    btnTxt2 : string = 'NO';
    fin_Type: string = '';
    btnLoader: boolean = false;
    resultmsg!:string
    panName!:string
    bankName!:string
    misMatchStatus!: number | string;
    isSuccess!:boolean
    userSession! : UserSession

    fraud_Msg = `<h4>Your bank statement has been rejected, Kindly upload another income proof or a valid bank statement.</h4></br>
                <h5>Follow the below points to avoid bank statement rejection</h5></br>
                <ul class="bullet">
                    <li><p>Upload latest 6 month statement</p></li>
                    <li><p>Name on bank statement should be same as name on PAN</p></li>
                    <li><p>File should be download from banks net banking platform</p></li>
                    <li><p>Upload original bank statement file without renaming</p></li>
                    <li><p>Do not print the PDF (Print as PDF)</p></li>
                    <li><p>Do not remove password </p></li>
                </ul>`;

    statusBaseMsg: any = {
        0: {
            heading: 'Bank statement could not be fetched.',
            contant1: 'We are unable to fetch your bank statement. Please try again later.',
            contant2: 'Do you wish to upload income proof other than bank statement?'
        },
        2: {
            heading: 'Missing details',
            contant1:
                'Bank statement does not contain transactions for the period From ( month, year) to ( month Year).',
            contant2: 'Fetch bank statement from some other bank?'
        },
        3: {
            heading: 'Bank statement could not be fetched.',
            contant1: 'We are unable to fetch your bank statement. Please try again later.',
            contant2: 'If the problem persists, please upload your bank statement.'
        },
        5: {
            heading: 'Bank statement could not be fetched.',
            contant1: 'We are unable to fetch your bank statement. Please try again later.',
            contant2: 'If the problem persists, please upload your bank statement.'
        }
    };

    constructor(
        private commonService: CommonService,
        private datePipe: DatePipe,
        private _bottomSheet: MatBottomSheet,
        private ActivaRoute: ActivatedRoute,
        private router: Router,
        private utilService: UtilService,
        private constantService: ConstantService,
        private modificationCommonService : ModificationCommonService,
        private userSessionService : UserSessionService,
        private _snackbar: MatSnackBar,
        private matDialog : MatDialog

    ) {
        this.userSession = userSessionService.getUserSessionData()
        ActivaRoute.queryParams.subscribe((params:any) => {
            this.session_id = params.session_id;
            this.isSuccess = params.success;
            this.pushSegmentResponse = JSON.parse(params.response);
            this.respStatus = this.pushSegmentResponse.status;
            const resultmsg = this.pushSegmentResponse.message;
            if(this.respStatus == 3)
            {
                this.misMatchStatus = this.pushSegmentResponse.data.nameMismatchStatus.status
                if(this.misMatchStatus == 0){
                    this.btnTxt = "Fetch another bank Statement"
                }else if (this.misMatchStatus == 1){
                    this.btnTxt = "YES"
                }
                this.respMsg = this.pushSegmentResponse.data.nameMismatchStatus.message
                this.panName = this.pushSegmentResponse.data.nameMismatchStatus?.panName
                this.bankName = this.pushSegmentResponse.data.nameMismatchStatus?.bankName
            }else if(this.respStatus == 8){
              this.bankPan  = this.pushSegmentResponse.data.panMismatchStatus.panAsPerBank
                this.clientPan = this.pushSegmentResponse.data.panMismatchStatus.panAsPerRecord
                 this.respMsg = this.pushSegmentResponse.message
            }
            else 
            {
              if (resultmsg.includes('fraud') || resultmsg.includes('Fraud')) {
                    this.respMsg = this.fraud_Msg;
                } else {
                    this.respMsg = this.pushSegmentResponse.message;
                }
                this.btnTxt = this.respStatus == 0 ? 'Retry' : 'YES';
            }

            this.fin_Type = this.pushSegmentResponse.data.finboxType;
           
        });
    }

    bankPan = ""
    clientPan = ""

    async getVendorStatus(session_id: string) {
        const appSource: string  = this.userSessionService.getUserSessionData().appSource
        const clientCode: string  = this.userSessionService.getUserSessionData().clientCode
        const salarySlab: any = JSON.parse(localStorage.getItem('salarySlab') || '') ;
        const vendorType = sessionStorage.getItem('vendorType') || '';
        const ismismatch =  this.respStatus == 3 ? true : false
        const parameter = clientCode + appSource + this.userSessionService.getUserSessionData().ip + session_id + salarySlab.ammout + vendorType + ismismatch + this.utilService.checkSumDate;

        const finBoxStatusReq: VendorStatusReq = {
            ipAddress: this.userSessionService.getUserSessionData().ip,
            appSource: this.userSessionService.getUserSessionData().appSource,
            checkSumValue: this.utilService.GenerateCheckSum(parameter),
            clientCode:this.userSessionService.getUserSessionData().clientCode,
            incomeSlab: salarySlab.ammout,
            isNameMatch: ismismatch,
            sessionId: session_id,
            isLastAttempt: false,
            isFinboxSessionSuccess: vendorType=="FINBOX" ? true : false,
            vendorType: vendorType,
            vendorRedirectPayload : sessionStorage.getItem('ecresParam') || '',
            docName: ismismatch ? this.bankName : ''
        };

        this.commonService.getVendorStatus(finBoxStatusReq).subscribe({next : (response:any) => {
          this.btnLoader = false;
          const status = response.status;
          if (status == 1) {
              this.router.navigateByUrl('/derivative/successfull-request');
          }
        },error:(err)=>{
            this.btnLoader = false
            this.misMatchStatus = ""
            const status = err.error.status
            if (status == 0 || status == 2 || status == 3 || status == 7 || status == 8 || status == 9) {
                this.respStatus = status;
                const resultmsg =  err.error.message
                if(status == 3 ){
                    this.misMatchStatus = err.error.data.nameMismatchStatus.status
                   
                    if(this.misMatchStatus == 0){
                        this.btnTxt = "Fetch another bank Statement"
                    }else if (this.misMatchStatus == 1){
                          this.btnTxt = "YES"
                    }
                    this.respMsg = err.error.data.nameMismatchStatus.message
                    this.panName = err.error.data.nameMismatchStatus?.panName
                    this.bankName = err.error.data.nameMismatchStatus?.bankName

                } else if (status == 8)
                { 
                    this.respStatus  = err.error.status
                    this.bankPan  = err.error.data.panMismatchStatus.panAsPerBank
                    this.clientPan = err.error.data.panMismatchStatus.panAsPerRecord
                     this.respMsg = err.error.message
                }
                else {
                    this.bankName = ""
                    this.panName = ""
                if (resultmsg.includes('fraud') || resultmsg.includes('Fraud')) {
                    this.respMsg = this.fraud_Msg;
                } else {
                    this.respMsg = err.error.message;
                }
                this.btnTxt = this.respStatus == 0 ? 'Retry' : 'YES';
            }
                  
            }
            else if (status == 6) {
                this._snackbar.openFromComponent(SnackbarComponent, {
                    data: [err.error.message],
                    duration: this.constantService.snackBarDuration,
                    panelClass: ['failed-popup']
                });
                this.router.navigateByUrl('/derivative/fail-page');
            }
        }})
    }

    documentUploadBottomSheet(): void {
        this._bottomSheet.open(IncomeProofBottomsheetComponent);
    }

    openBottomSheet(): void {
        this._bottomSheet.open(ConfirmationBottomsheetComponent, {
            data: { session_id: this.session_id, status: this.respStatus }
        });
    }

    clickOnYes() {
        this.btnLoader = true;

        setTimeout(() => {
            this.misMatchStatus == 0? this.changeStyle():'';
          });
        
         this.respStatus == 3 ? this.misMatchStatus == 1 ? this.getVendorStatus(this.session_id) : this.getVendorURL() : this.getVendorURL();
    }

    clickOnNo() {
        if (this.respStatus != 3)
            clevertapPush('Segment_Activation_MOD', {
                parameter1: 'MOD_SEG_FIN_NM_NO',
                parameter2: 'Error_Occured',
                parameter3: 'Name_Mismatch'
            });

        // this.respStatus == 0 ? this.router.navigateByUrl('/fail-page') :
        this.openBottomSheet();
    }

    finBoxStatus() {
       clevertapPush('Segment_Activation_MOD', {
            parameter1: 'MOD_SEG_FIN_NM_YES',
            parameter2: 'Segment_Activation_Request_Submitted',
            parameter3: 'Error_Occured',
            parameter4: 'Name_Mismatch'
        });
        this.getVendorStatus(this.session_id);
    }

    finboxSDKURL() {
        if (this.respStatus == 0) {
            clevertapPush('Segment_Activation_MOD', {
                parameter1: 'MOD_SEG_FIN_ERROR_RETRY',
                parameter2: 'Auto_Fetch_Failed',
                parameter3: 'Unable_To_Validate'
            });
        }
        clevertapPush('Segment_Activation_MOD', { action: 'MOD_SEG_FIN_MANUAL_YES' });
        this.getVendorURL()
    }

    changeStyle(newWidth: string = '227px') {
        this.loaderBtn.nativeElement.style.width = newWidth;
        this.loaderBtn.nativeElement.style.height = '37px';
      }

    ngAfterViewInit() {
        // 🔍 Get the computed styles of the button (defined via class)
        const styles = getComputedStyle(this.loaderBtn.nativeElement);
        console.log('Initial background-color:', styles.width);
    }
    
     async getVendorURL() {
          const returnUrl =
            window.location.hostname.includes('dev') 
                ? 'http://dev.5paisa.in:4200/derivative/loader'
                : 'https://' + window.location.hostname + '/derivative/loader';   
              //appSource (In UPPER Case) + clientCode + ipAddress + redirectUrl + vendorType
              this.btnLoader = true;
              const checksum = this.userSession.appSource.toUpperCase() +  this.userSession.clientCode  + this.userSession.ip + returnUrl + 'FINBOX' + this.utilService.checkSumDate
              sessionStorage.setItem('vendorType','FINBOX')
              const getVendorURLReq: GetVendorURLReq = {
                appSource:  this.userSession.appSource,
                ipAddress: this.userSessionService.getUserSessionData().ip,
                checkSumValue: this.utilService.GenerateCheckSum(checksum),
                clientCode: this.userSessionService.getUserSessionData().clientCode,
                redirectUrl: returnUrl,
                userId: this.userSessionService.getUserSessionData().clientCode,
                vendorType :  'FINBOX'
              };
        this.commonService.getVendorURL(getVendorURLReq).subscribe({
          next: (response) => {
           sessionStorage.setItem('sessionId', response.data.sessionId);
          this.cardSubmit(response.data.redirectUrl)
            // window.location.href = response.data.redirectUrl;
        },error : (err)=>{
        },})
    }

     async cardSubmit(url:string) {
          const isMobile = window.innerWidth <= 768;
          if (isMobile) {
          // Open as bottom sheet on mobile
          this._bottomSheet.open(LoaderbotomsheetComponent, { 
            disableClose: true,
            data: {
                url:url
              }
          });
          } else {
          // Open as dialog on desktop/web
            this.matDialog.open(LoaderbotomsheetComponent, {
              width: '360px',
              height: '286px',
              panelClass: 'custom-dialog-container',
              disableClose: true,
              data: {
                url:url
              }
            });
          }
        }

}